export default {
  props: {
    value: null,
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    controls: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    itemClass(control) {
      const isActive = control[this.valueKey] === this.value;
      return isActive ? {
        'el-bg-color-primary-6': true,
        'el-color-gray-1': true
      } : {
        'el-color-primary-1': true,
        'el-bg-color-primary-2-hover': true
      };
    },

    select(control) {
      // 再次点击取消选择
      if (control[this.valueKey] === this.value) {
        this.$emit('input', undefined);
        return;
      }

      this.$emit('input', control[this.valueKey]);
    }

  }
};